/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, View, type StyleProp, type ViewStyle } from 'react-native';
import { styles } from './CatalogMastersScreen.styles';

type Props = {
  label: string;
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  /** Error inline del campo (validación / duplicados). Se anuncia con liveRegion. */
  error?: string | null;
};

/**
 * Campo con etiqueta persistente (visible aunque el input tenga valor).
 * Si `error` llega, lo muestra debajo; los consumidores tiñen el borde del
 * input con `styles.formInputError`.
 */
export function MasterFormField({ label, children, style, error }: Props) {
  return (
    <View style={[styles.formField, style]}>
      <Text style={styles.formLabel} accessibilityRole="text">
        {label}
      </Text>
      {children}
      {error ? (
        <Text
          style={styles.formFieldError}
          accessibilityRole="alert"
          accessibilityLiveRegion="polite"
        >
          {error}
        </Text>
      ) : null}
    </View>
  );
}
